<div class="container text-center" [hidden]='!loading'>
    <p>Checking...</p>
</div>

<div class="container text-center" [hidden]='loading'>
    <h1 class="mt-3">You are not authorized to view this page.</h1>
</div>